import { ModalBody } from "react-bootstrap";
import AppModal from ".";
import { useLanguageContext } from "../../../context";

const ImageModal = ({ image, setToggle, toggle, handleImage, handleRemoveImage }) => {
  const { I18n } = useLanguageContext();

  const handleClose = (event) => {
    setToggle(false);
  };

  const handleDelete = () => {
    handleRemoveImage();
    setToggle(false);
  }

  return (
    <AppModal
      className="imageModalMain"
      title={I18n.item_image}
      toggle={toggle}
      handleClose={handleClose}
      primaryCta={{
        title: I18n.delete,
        action: handleDelete,
      }}
      uploadCta={{
        title: I18n.upload_image,
        action: handleImage,
      }}
    >
      <ModalBody>
        <div className="imageModaImage">
          <img src={image} alt="profile" style={{ resizeMode: "cover" }} />
        </div>
      </ModalBody>
    </AppModal>
  );
};

export default ImageModal;
